import { Languages } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { track } from "@/lib/analytics";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const target = lang === "en" ? "te" : "en";
  return (
    <button
      data-testid="language-toggle"
      onClick={() => { setLang(target); track("language_changed", { language: target }); }}
      className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#5A2D1D] hover:text-[#7A3B25] transition-colors px-2.5 py-1 border border-[#5A2D1D]/30 rounded-full ${className}`}
      title="Switch language"
    >
      <Languages className="w-3.5 h-3.5" />
      <span data-testid="language-current">{target === "te" ? "తెలుగు" : "English"}</span>
    </button>
  );
};
